"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessagePanelActionsContext = void 0;
const react_1 = require("react");
exports.MessagePanelActionsContext = (0, react_1.createContext)({});
